import { Transaction } from 'prosemirror-state'

import { KeyhandlerMetadata } from 'common/Prose/types'

import { breakOutOfList } from './breakOutOfList'
import { deleteCellContents } from './deleteCellContents'
import { joinBackward } from './joinBackward'
import { liftEmptyBlock } from './liftEmptyBlock'
import { pullThroughDeleted } from './pullNextItem'
import { splitBlock } from './splitBlock'
import { splitListItemOnGapCursor } from './splitListItemOnGapCursor'
import { CommandTrackerProps, type TrackedChangeCommand } from './types'

export function specialCaseHandling({ keydown, handlerName }: KeyhandlerMetadata, props: CommandTrackerProps): boolean {
  if (handlerName === 'deleteCellContents' && deleteCellContents(props)) {
    return true
  }
  if (handlerName === 'breakOutOfList' && breakOutOfList(props)) {
    return true
  }
  if (keydown === 'Delete' && ['mergeBackwardsIntoListItem', 'pullNextItem', 'default'].includes(handlerName) && pullThroughDeleted(props)) {
    return true
  }
  if (handlerName === 'splitBlock' && splitBlock(props)) {
    return true
  }
  if (keydown === 'Backspace' && ['mergeBackwardsIntoListItem', 'pullNextItem'].includes(handlerName) && joinBackward(props)) {
    return true
  }
  if (handlerName === 'joinBackward' && joinBackward(props)) {
    return true
  }
  if (handlerName === 'splitListItemOnGapCursor' && splitListItemOnGapCursor(props)) {
    return true
  }
  if (handlerName === 'liftEmptyBlock' && liftEmptyBlock(props)) {
    return true
  }
  if (handlerName === 'maybeLiftEmptyBlock' && liftEmptyBlock(props)) {
    return true
  }
  return false
}

export const setTrackedChangeCommand = (tr: Transaction, command: TrackedChangeCommand) => {
  tr.setMeta('trackedChangeCommand', command)
}

export const getTrackedChangeCommand = (tr: Transaction): TrackedChangeCommand | undefined => {
  return tr.getMeta('trackedChangeCommand')
}
